<app-otp-general credType="email" niceOtpName="Email"></app-otp-general>
